/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable @typescript-eslint/indent */
import {
    Alert,
    Button,
    HStack,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Text,
} from '@chakra-ui/react';
import { ServiceCheckbox } from '@acp/core-ui';
import { ServiceIdMapper } from '@acp/shared';
import { useFormContext } from 'react-hook-form';
import { PropertyAddressCard } from '../property-address-card';
import { RequestHoldingServiceFormFormValues } from './form-schema';
import { useProperty } from '../../hooks/use-property';

function ConfirmServiceOnHoldScreen({
    propertyId,
    onBack,
    onSubmit,
    isLoading,
    error,
}: {
    propertyId: number;
    onSubmit: (vals: RequestHoldingServiceFormFormValues) => void;
    onBack: () => void;
    isLoading: boolean;
    error: Error | null;
}) {
    const propertyHoldingServiceQuery = useProperty(propertyId);
    const form = useFormContext<RequestHoldingServiceFormFormValues>();
    const serviceIds = form.watch('services');
    const isMultipleServicesSelected = serviceIds.length > 1;

    return (
        <>
            <ModalHeader>Confirm service hold</ModalHeader>
            <ModalBody>
                <PropertyAddressCard w="full" mb={5} propertyId={propertyId} />

                <Text fontWeight="medium" fontSize="md" mb={2}>
                    {`Service${
                        isMultipleServicesSelected ? 's' : ''
                    } to be placed on hold`}
                </Text>

                {propertyHoldingServiceQuery.data !== undefined && (
                    <HStack gap={2} w="full" flexWrap="wrap" mb={5}>
                        {propertyHoldingServiceQuery.data.services
                            .filter((x) => serviceIds.includes(x.serviceId))
                            .map((service) => (
                                <ServiceCheckbox
                                    key={service.serviceId}
                                    serviceName={ServiceIdMapper.getFormattedServiceName(
                                        service.shortName
                                    )}
                                    onChange={() => {}}
                                    isChecked={false}
                                    hideCheckbox
                                />
                            ))}
                    </HStack>
                )}

                <Text fontWeight="bold" fontSize="lg" mb={2}>
                    What happens next?
                </Text>

                <Text>
                    Your request will be sent to our team for review.
                    <br />
                    {`We will process your request within the next 48 hours and will notify
                    you once the service${
                        isMultipleServicesSelected ? 's have' : ' has'
                    } been put on hold.`}
                </Text>

                {error !== null && (
                    <Alert title="An error occurred while submitting your request. Please try again." status="error" mt={5}>
                        {error.message}
                    </Alert>
                )}
            </ModalBody>

            <ModalFooter justifyContent="space-between">
                <Button colorScheme="muted" variant="ghost" onClick={onBack}>
                    Back
                </Button>
                <Button
                    colorScheme="secondary"
                    onClick={form.handleSubmit(onSubmit)}
                    isLoading={isLoading}
                >
                    Request hold
                </Button>
            </ModalFooter>
        </>
    );
}

export { ConfirmServiceOnHoldScreen };
